import React from 'react';

import RangePickerLib, { Props } from '@zero5/ui/lib/RangePicker';

import useDateModule from '@/utils/date/useDateModule';

const RangePicker: React.FC<Props> = (props) => {
  const { z5DateModule } = useDateModule();

  return (
    <RangePickerLib
      timezone={z5DateModule.getTimezone()}
      {...props}
    />
  );
};

export default RangePicker;
